import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import ServicesHero from "./sections/ServicesHero";
import AllDentalServices from "./sections/AllDentalServices";
import ContactCta from "./sections/ContactCta";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <ServicesHero />
      <AllDentalServices />
      <ContactCta />
      <Footer />
    </div>;
}